"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.localeNames = exports.setupInternationalization = exports.getEnabledLocales = exports.useDeXDuLocale = void 0;
const translations_1 = __importDefault(require("../../common/translations"));
const localeNames = {
    ab: "Albanian",
    ar: "Arabic",
    ca: "Català",
    da: "Dansk",
    de: "Deutsch",
    en: "English",
    el: "Ελληνικά",
    es: "Español",
    fi: "Suomalainen",
    fr: "Français",
    it: "Italiano",
    nl: "Netherlands",
    no: "Norsk",
    pt: "Português",
    pl: "Polski",
    tr: "Türkçe",
    sv: "Svenska",
    ru: "Русский",
    hr: "Hrvatski",
    nb: "Norsk",
    ja: "日本語",
    zh: "中文 (简体)",
    ro: "Romana",
    hu: "Magyar",
    cs: "Český",
    sl: "Slovenščina",
    vi: "Tiếng Việt",
};
exports.localeNames = localeNames;
// DeXDu is the correct wording which is used in the core project.
const useDeXDuLocale = (brandSlug, venueSlug) => (brandSlug === "robinson-club" ||
    brandSlug === "nordic-wave-hotels" ||
    brandSlug === "upstalsboom-wyk-auf-foehr" ||
    venueSlug.includes("arborea"));
exports.useDeXDuLocale = useDeXDuLocale;
const getEnabledLocales = (venue) => venue.enabledLocales.map((locale) => ({
    name: localeNames[locale],
    abbreviation: locale,
}));
exports.getEnabledLocales = getEnabledLocales;
const setupInternationalization = (locale, venue) => {
    if (locale === "de" && (0, exports.useDeXDuLocale)(venue.brandSlug, venue.slug)) {
        translations_1.default.locale = "derobinson";
    }
    else {
        translations_1.default.locale = locale;
    }
    translations_1.default.currentLocale();
};
exports.setupInternationalization = setupInternationalization;
